export const COLORS = {
    red: {
        50: "#fef2f2",
        100: "#ffe2e2",
        200: "#ffcaca",
        300: "#ffa3a3",
        400: "#ff6568",
        500: "#fb2c36",
        600: "#e40014",
        700: "#bf000f",
        800: "#9f0712",
        900: "#82181a",
        950: "#460809",
    },
    orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#ffd7a8",
        300: "#ffb96d",
        400: "#ff8b1a",
        500: "#fe6e00",
        600: "#f05100",
        700: "#c53c00",
        800: "#9f2d00",
        900: "#7e2a0c",
        950: "#441306",
    },
    amber: {
        50: "#fffbeb",
        100: "#fef3c6",
        200: "#fee685",
        300: "#ffd236",
        400: "#fcbb00",
        500: "#f99c00",
        600: "#dd7400",
        700: "#b75000",
        800: "#953d00",
        900: "#7b3306",
        950: "#461901",
    },
    yellow: {
        50: "#fefce8",
        100: "#fef9c2",
        200: "#fff085",
        300: "#ffe02a",
        400: "#fac800",
        500: "#edb200",
        600: "#cd8900",
        700: "#a36100",
        800: "#874b00",
        900: "#733e0a",
        950: "#432004",
    },
    lime: {
        50: "#f7fee7",
        100: "#ecfcca",
        200: "#d8f999",
        300: "#bbf451",
        400: "#9de500",
        500: "#80cd00",
        600: "#62a400",
        700: "#4b7d00",
        800: "#3d6300",
        900: "#35530e",
        950: "#192e03",
    },
    green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#b9f8cf",
        300: "#7bf1a8",
        400: "#05df72",
        500: "#00c758",
        600: "#00a544",
        700: "#008138",
        800: "#016630",
        900: "#0d542b",
        950: "#032e15",
    },
    emerald: {
        50: "#ecfdf5",
        100: "#d0fae5",
        200: "#a4f4cf",
        300: "#5ee9b5",
        400: "#00d294",
        500: "#00bb7f",
        600: "#009767",
        700: "#007956",
        800: "#005f46",
        900: "#004e3b",
        950: "#002c22",
    },
    teal: {
        50: "#f0fdfa",
        100: "#cbfbf1",
        200: "#96f7e4",
        300: "#46ecd5",
        400: "#00d3bd",
        500: "#00baa7",
        600: "#009588",
        700: "#00776e",
        800: "#005f5a",
        900: "#0b4f4a",
        950: "#022f2e",
    },
    cyan: {
        50: "#ecfeff",
        100: "#cefafe",
        200: "#a2f4fd",
        300: "#53eafd",
        400: "#00d2ef",
        500: "#00b7d7",
        600: "#0092b5",
        700: "#007492",
        800: "#005f78",
        900: "#104e64",
        950: "#053345",
    },
    sky: {
        50: "#f0f9ff",
        100: "#dff2fe",
        200: "#b8e6fe",
        300: "#77d4ff",
        400: "#00bcfe",
        500: "#00a5ef",
        600: "#0084cc",
        700: "#0069a4",
        800: "#005986",
        900: "#024a70",
        950: "#052f4a",
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bedbff",
        300: "#90c5ff",
        400: "#54a2ff",
        500: "#3080ff",
        600: "#155dfc",
        700: "#1447e6",
        800: "#193cb8",
        900: "#1c398e",
        950: "#162456",
    },
    indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2ff",
        300: "#7d87ff",
        400: "#818cf8",
        500: "#625fff",
        600: "#4f39f6",
        700: "#432dd7",
        800: "#372aac",
        900: "#312c85",
        950: "#1e1a4d",
    },
    violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6ff",
        300: "#c4b4ff",
        400: "#a685ff",
        500: "#8d54ff",
        600: "#7f22fe",
        700: "#7008e7",
        800: "#5d0ec0",
        900: "#4d179a",
        950: "#2e1065",
    },
    purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d9b3ff",
        400: "#c07eff",
        500: "#ac4bff",
        600: "#9810fa",
        700: "#8200da",
        800: "#6e11b0",
        900: "#59168b",
        950: "#3c0366",
    },
    fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f6cfff",
        300: "#f2a9ff",
        400: "#ec6cff",
        500: "#e12afb",
        600: "#c600db",
        700: "#a600b5",
        800: "#8a0194",
        900: "#721378",
        950: "#4b004f",
    },
    pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fccee8",
        300: "#fda5d5",
        400: "#fb64b6",
        500: "#f6339a",
        600: "#e30076",
        700: "#be185d",
        800: "#a2004c",
        900: "#861043",
        950: "#510424",
    }
} as const;